import React from 'react';
import Main from '../../components/Main';
import { useNavigate } from 'react-router-dom';
import {Row, Col, Image, Button } from 'react-bootstrap';
import LongCard from '../../components/LongCard';
import register from '../../assets/images/register.png';
import '../../assets/styles/Global.css';

// ExecPartners Subpage of AboutUs Page

const images = {};

function importAll(r) {
  r.keys().forEach((key) => {
    images[key.replace('./', '')] = r(key);
  });
}


// Imports all images from the execpartners folder into the images array

importAll(require.context('../../assets/images/aboutus_icons/execpartners', false, /\.(png|jpe?g|svg)$/));

const execpartners = [
  {
    title: "Leverage your professional relationships",
    description: "Increase your revenues by 2x to 3x",
    details : `By joining our IQosys as an Exec Partners, you’ll be able to leverage your professional relationships and extend your footprint across various functional domains, rather than being confined to your own area of expertise. This strategic advantage typically results in earnings increases by factors of 2 to 3.`,
    icon: images['execpartners_1.png'],
  },
  {
    title: "Respond to large RFPs, requiring teams of consultants ",
    description: "Deliver transformative business outcomes",
    details : `You’ll have the opportunity to manage larger, more complex projects that necessitate cross-functional teams of experts and project directors, enhancing both your professional growth and financial rewards. Our structured marketing programs and networking events are designed to facilitate the opening of new client accounts, enabling you to expand your business reach and client base.`,
    icon: images['execpartners_2.png'],
  },
  {
    title: "Access to the Deal Desk©",
    description: "Selling is part art, part science – our Deal Desk will boost your closing stats",
    details : `We have extensive experience managing sales pipelines of high value professional services. You can tap into this experience through our Deal Desk which will help you prioritize and advance your leads using MEDDPICC (Metrics, Exec-buyer, Decision criteria, Decision process, Paper process, Identify pains, Champion building & Competition), to influence key stakeholders through a Control Of The Message approach to maximize your closing rates.`,
    icon: images['execpartners_3.png'],
  },
  {
    title: "Join a partnership with an equity stake in the business",
    description: "Earn, buy and sell equity on the secondary market",
    details : `The IQosys AD Token program provides access to equity based on your individual contributions, enabling you to monetize your client portfolio in ways that are difficult as a small firm owner. In addition to the financial impact of owning equity, you’ll be able to participate in the firm’s governance and strategic direction.`,
    icon: images['execpartners_4.png'],
  },
  {
    title: "Be your own boss",
    description: "Focus on doing work you enjoy, instead of achieving quotas",
    details : `Working within our network means you set your own pace and work rhythm, free from the pressure of quotas set by others. This autonomy allows you to focus on delivering exceptional client service rather than getting bogged down by internal operations and hierarchy.`,
    icon: images['execpartners_5.png'],
  },
  {
    title: "Join the IQ based meritocracy",
    description: "No politics, just business",
    details : `Our firm operates on a no politics, no frills, 100% meritocracy model, ensuring that everyone is their own boss and your success is driven purely by your contributions and client satisfaction. Join us and transform your career into a more lucrative and fulfilling professional journey.`,
    icon: images['execpartners_6.png'],
  },
];

const ExecPartners = () => {
  const navigate = useNavigate();
  const handleRegisterClick = () => {
    navigate('/myaccount/register'); // Redirect to the Register page
  };
  
  return (
    <div>
      <Main componentList={[
          <h6 className='top_sentence'>If you’re a seasoned consultant looking for a steep growth opportunity, IQosys is for you</h6>,
          <h7>IQosys is managed by a team of experienced, highly driven Executive Partners with backgrounds from the leading strategy, management and IT consulting firms. Here are 6 reasons why you should consider IQosys for your next career step.</h7>,
        <Col className="mt-4">
          {execpartners.map((execpartner, index) => (
            <Row md={6} lg={1} key={index}>
              <LongCard className="h-100 shadow-sm" longcard={execpartner}/>
            </Row>
          ))}
        </Col>,
        <hr className="my-custom-hr"/>,
        <Button variant="light" 
          className="mt-auto btn-sm text-start align-self-start border-0"  
          onClick={handleRegisterClick}
          style={{ 
            backgroundColor: "white", 
            boxShadow: "none",
          }}
        >
          <div className="d-flex align-items-center" style={{marginBottom:"10px"}}>
            <Image src={register} width={32} height={32} alt="Register Icon" />
            <span className='ms-2' style={{color: "#7300FF", fontWeight: "bold"}}>Apply to join</span>
          </div>
        </Button>
      ]} />
    </div>
  );
};

export default ExecPartners;